export default "/react/tiktok_ads-e6f30e7d.svg";